module.exports = __webpack_public_path__ + "media/images/fish-5a363cc1.png";